import InputLabelStyled from "@/components/InputLabelStyled";
import { MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid";
import SelectStyled from "../SelectStyled";

export const NumberOfMusiciansFilter = ({
  min,
  max,
  disabled = false,
  onChange,
}) => {
  const handleInputChanged = (event, value = null) => {
    if (onChange) {
      onChange(event, value);
    }
  };

  const numbers = () => {
    let allNumbers = [];
    for (var i = 1; i <= 100; i++) {
      allNumbers = [...allNumbers, i];
    }

    return allNumbers;
  };

  return (
    <>
      <InputLabelStyled disabled={disabled} label="Anzahl der Musiker:innen" />
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <SelectStyled
            values={numbers}
            onChange={handleInputChanged}
            placeholder="Mindestens"
            menuProps="LimitHeight"
            name="members_min"
            value={min}
            allowEmpty={true}
            disabled={disabled}
          >
            {numbers().map((option, key) => (
              <MenuItem value={option} key={key}>
                {option}
              </MenuItem>
            ))}
          </SelectStyled>
        </Grid>
        <Grid item xs={6}>
          <SelectStyled
            values={numbers}
            onChange={handleInputChanged}
            placeholder="Maximal"
            menuProps="LimitHeight"
            name="members_max"
            value={max}
            allowEmpty={true}
            disabled={disabled}
          >
            {numbers().map((option, key) => (
              <MenuItem value={option} key={key}>
                {option}
              </MenuItem>
            ))}
          </SelectStyled>
        </Grid>
      </Grid>
    </>
  );
};
